module.exports = __webpack_public_path__ + "static/media/accounts.f9a0a83b.png";